import { formatCurrency, formatDate } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { ColWidth, colWidthClass } from "./col-width";

@Component({
  template: "",
})
export class FormControlElement {
  @Input() control!: FormControl;
  @Input() updateOn: "change" | "blur" | "submit" = "change";
  /** Breedte van het invoerveld: 'small' | 'medium' | 'large'. Niet ingesteld = volle breedte. */
  @Input() colWidth?: ColWidth;

  /** Bootstrap-kolomklasse die hoort bij de ingestelde colWidth (col-lg-12 indien niet ingesteld). */
  colClass(): string {
    return colWidthClass(this.colWidth);
  }

  required(): boolean {
    if (this.control) return this.control.hasValidator(Validators.required);
    return false;
  }

  formatDate(value: any) {
    return formatDate(value, "dd/MM/yyyy", "nl-BE");
  }

  formatCurrency(value: any, decimals: number = 2) {
    return formatCurrency(value, "nl-BE", "", "EUR", `1.2-${decimals}`);
  }
}
